import { ActionIcon, Button, Code, Modal, Text, Tooltip, useMantineTheme } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { copyToClipboard, useCollaborateStore } from '@mygpt/app';

import classes from './index.module.css';

interface props {
  getBack: () => void;
}

type iframeStateParam = 'gptBaseWidgetOpened' | 'gptBaseWidgetClose';

export const getWidgetCodeTemp = (id: string) => {
  return `<script>
  window.gptbaseConfig = {
    chatbotId: '${id}',
    baseUrl: '${window.location.origin}',
    apiBaseUrl: '${window.location.origin}/api',
  };
</script>
<script
  src="${
    import.meta.env.VITE_STAGE === 'customer' ? window.location.origin : import.meta.env.VITE_BASE_HOST
  }/plugin/plugin.js"
  id="${id}"
  defer>
</script>`;
};

export const ModalWidget = ({
  close,
  hideSetting,
  opened,
}: {
  opened: boolean;
  close: () => void;
  hideSetting?: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const WIDGET_CODE_TEMP = getWidgetCodeTemp(id || '');

  const { isAssist } = useCollaborateStore();

  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(!copied);
      }, 1 * 1000);
    }
  }, [copied]);

  return (
    <Modal title={t('widget.modal.title')} size="lg" centered opened={opened} onClose={close}>
      <Text size={'sm'} mb={20}>
        {t('widget.modal.text')}
      </Text>
      {!hideSetting && (
        <Button
          size="sm"
          mb={20}
          onClick={() => {
            navigate(`/${isAssist ? 'assist' : 'bot'}/${id}/widget-embed`);
          }}
        >
          {t('setting')}
        </Button>
      )}

      <Code block color={theme.colors.dark[1]} style={{ position: 'relative' }}>
        <Tooltip label={'Copy'} withArrow position="left">
          <ActionIcon
            variant="subtle"
            style={{ position: 'absolute', right: 10, top: 10 }}
            color={'gray'}
            onClick={() => {
              const copied = copyToClipboard(WIDGET_CODE_TEMP);
              setCopied(!!copied);
            }}
          >
            {copied ? <IconCheck color="teal" size="1rem" /> : <IconCopy color="gray" size="1rem" />}
          </ActionIcon>
        </Tooltip>

        {WIDGET_CODE_TEMP}
      </Code>
    </Modal>
  );
};
